import api, {downloadFile, uploadFile} from '@pb/middleware-api';

import getRoot from './getRoot';

export const ROOT = getRoot();

export const API_ROOT = `${ROOT}`;

export default api({
    apiRoot: API_ROOT,
    uploadFile,
    downloadFile,
});

export const ERROR = {
    reason: 'INTERNAL_SERVER_ERROR',
    message: 'There was an issue with your request. Please try again.',
};
